import React from "react";
import Reveal from "./Reveal";
import { Building2, Sparkles, UserCog } from "lucide-react";

const CARDS = [
  {
    icon: Building2,
    title: "Pymes con ventas pero demasiado caos interno",
    text: "Facturas, pero días saturados. Negocio en marcha, pero sin claridad de qué mueve los números.",
  },
  {
    icon: Sparkles,
    title: "Negocios que quieren usar IA sin tirar dinero",
    text: "Sin enamorarse de herramientas. Con foco en ROI real, no en demos.",
  },
  {
    icon: UserCog,
    title: "Empresarios que sienten que todo depende demasiado de ellos",
    text: "Tu cabeza es el cuello de botella. Lo que no está fuera, no se puede mejorar.",
  },
];

const WhoFor = () => {
  return (
    <section data-testid="whofor-section" className="et-section relative">
      <div className="et-container relative z-10">
        <div className="max-w-3xl">
          <Reveal>
            <div className="et-eyebrow">Para quién</div>
          </Reveal>

          <Reveal delay={0.08}>
            <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.05] text-white et-text-balance">
              Para quién{" "}
              <span className="et-text-gold">tiene sentido.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-5 text-base md:text-lg text-[#f5f2ea]/90 max-w-2xl leading-relaxed">
              Si tu proceso no está claro, la IA no te va a salvar. Pero sí
              puede ayudarte a ir mucho más rápido cuando ordenamos la base.
            </p>
          </Reveal>
        </div>

        <div className="mt-10 md:mt-12 grid md:grid-cols-3 gap-5 md:gap-6">
          {CARDS.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.08}>
              <div
                className="et-card h-full"
                data-testid={`whofor-card-${i}`}
              >
                <div className="flex items-center gap-3 mb-5">
                  <div
                    className="w-11 h-11 rounded-xl grid place-items-center"
                    style={{
                      background: "rgba(197,160,89,0.1)",
                      border: "1px solid rgba(197,160,89,0.3)",
                    }}
                  >
                    <c.icon className="w-5 h-5 text-[#c5a059]" />
                  </div>
                </div>
                <h3 className="text-lg md:text-xl font-semibold text-white tracking-tight leading-snug">
                  {c.title}
                </h3>
                <p className="mt-3 text-sm md:text-base text-[#f5f2ea]/80 leading-relaxed">
                  {c.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoFor;
